import { render } from "./Index.vue?vue&type=template&id=dd677e74"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Pages/Booking/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dd677e74"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dd677e74', __exports__)) {
    api.reload('dd677e74', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=dd677e74", () => {
    api.rerender('dd677e74', render)
  })

}


export default __exports__